enum Constants {
    APP_VERSION = '5.0.5',
    EINSTEIN_DOMAIN = 'einsteinbros.com',
    NOAH_DOMAIN = 'noahs.com',
    BRUEGGERS_DOMAIN = 'brueggers.com',
    EINSTEIN_APP = 'ebbApp',
    NOAH_APP = 'NoahsApp',
    BRUEGGERS_APP = 'bruApp',
    EBB_CDN_NAME = 'da-store-ebb',
    BRU_CDN_NAME = 'da-store-bru',
    NNYB_CDN_NAME = 'da-store-nnyb',
    EBB_TITLE = 'EINSTEIN BROS. BAGELS',
    NNYB_TITLE = 'NOAH\'S BAGELS',
    BRU_TITLE = 'BRUEGGER\'S BAGELS',
    EBB_APP = 'EBBApp',
    EBB_ORDER_AHEAD_WEB = 'EbbOrderAheadWeb',
    BRU_APP = 'BRUApp',
    BRU_ORDER_AHEAD_WEB = 'BruOrderAheadWeb',
    NNYB_APP = 'NoahsApp',
    NNYB_ORDER_AHEAD_WEB = 'NnybOrderAheadWeb',
    BRU_YEXT_VALUE = "BRUEGGER'S_BAGELS",
    NNYB_YEXT_VALUE = "NOAH'S_BAGELS",
    EBB_YEXT_VALUE = "EINSTEINBROSBAGELS",
    RESET_PASSWORD_BRAND_EBB = "EBB",
    RESET_PASSWORD_BRAND_BRU = "BRU",
    RESET_PASSWORD_BRAND_NNYB = "NNYB",
    EBB_NUTRITION_URL = 'https://www.einsteinbros.com/wp-content/uploads/2024/03/EBB-Nutrition-Guide-Master-2.pdf',
    NNYB_NUTRITION_URL = 'https://www.noahs.com/wp-content/uploads/NNYB-Nutrition-Guide-Master-2.pdf',
    BRU_NUTRITION_URL = 'https://www.brueggers.com/wp-content/uploads/2024/03/BRU-Nutriton-Guide-Master-1.pdf',
    WALK_IN = "WALK-IN",
    WALK_IN_DESC = "Head into the store and pick up your order.",
    DRIVE_THRU = "DRIVE-THRU",
    DRIVE_THRU_DESC = "Jump in the drive-thru line and let us know you have a mobile order waiting.",
    CURBSIDE = "CURBSIDE",
    CURBSIDE_DESC = "Place your order and let us know when you arrive. We will bring your items to your vehicle.",
    GUEST_TERMS_CONDITIONS = "https://bagelbrands.com/terms-of-use/",
    NOAH_DEEP_LINK = "https://www.noahs.com/",
    BRU_DEEP_LINK = "https://www.brueggers.com/",
    EBB_DEEP_LINK = "https://www.einsteinbros.com/",
    NOAH_CATERING_LINK = "https://noahscatering.com/",
    BRU_CATERING_LINK = "https://catering.brueggers.com/",
    EBB_CATERING_LINK = "https://ebcatering.com/",
    NO_LOCATION_SELECTED = "No Location Selected",
    NO_PICKUP_TYPE = "No Pickup Type",
    NO_PICKUP_TIME = "No Pickup Time",
    NOW = "now",
    RESET_PASSWORD_LINK_EXPIRED = "The password reset link has expired and is no longer valid. Please :link again to receive a new email.",
    RESET_PASSWORD_FAILURE = "There was an error resetting your password. Please contact customer service for assistance.",
    RESET_PASSWORD_SUCCESS = "Password changed successfully! Please log in using your new password",
    SUCCESS = "Success",
    FAILURE = "Failure",
    FORGOT_PASSWORD_SUCCESS = "If the email provided is associated with an account, you will receive an email shortly with password reset instructions",
    FORGOT_PASSWORD_SUBTEXT = "If you've forgotten your password, or if you have never accessed your account before, input your email address below and we’ll send you an email to reset it.",
    FORGOT_PASSWORD_REPEAT = "You recently requested to reset your password. Please check your email to continue.",
    FORGOT_PASSWORD_FAILURE = "There was an error processing your password reset request. Please contact customer service for assistance.",
    EINSTEIN_PROGRAM_PREFERENCE = 'ebbProgram',
    NOAH_PROGRAM_PREFERENCE = 'nnybProgram',
    BRUEGGERS_PROGRAM_PREFERENCE = 'bruProgram',
    EBB_APP_TERMS_CONDITION_URL = 'https://bagelbrands.com/loyalty-program-terms-and-conditions/',
    BRU_APP_TERMS_CONDITION_URL = 'https://bagelbrands.com/loyalty-program-terms-and-conditions/',
    NNYB_APP_TERMS_CONDITION_URL = 'https://bagelbrands.com/loyalty-program-terms-and-conditions/',
    NOAH_REWARDS = "Noah's Rewards ",
    EBB_REWARDS = "Einstein Bros. Rewards ",
    BRU_REWARDS = "Bruegger's Bagels Rewards ",
    EBB_SIGNUP_HEADER_TEXT = "Join Rewards!",
    BRU_SIGNUP_HEADER_TEXT = "Join Rewards!",
    NNYB_SIGNUP_HEADER_TEXT = "Join Noah's Rewards!",
    REDIRECT_TO_HOME = "RedirectToHome",
    FORGOT_PASSWORD_TITLE = "Forgot Password",
    RESET_PASSWORD_TITLE = "Reset Password",
    DEFAULT_ERROR_MESSAGE = "Something went wrong! Please try again.",
    CHANGE_PASSWORD_FAILURE = "The current password does not match the password on the account. The password was not changed.",
    CHANGE_PASSWORD_SUCCESS = "Your password has been changed successfully",
    CARD_DELETE_ERROR_MSG = "Unable to delete the card. Please try again later!",
    CARD_UPDATE_ERROR_MSG = "Account registration was unsuccessful. Please check the account details.", // the same as mobile err msg
    CARD_GET_ERROR_MSG = "There was an error while obtaining your cards.",
    CARD_VAULT_ERROR_MSG = "There was an error while adding your new card. Please check card information and try again.",
    PAYMENT_FAILED_MSG = "Payment Failed. Please try again.",
    ORDER_SERVICE_ERROR_MSG = "Payment cannot be processed at this time.",
    ADD_PAYMENT_ERROR_MSG = "Add Payment Failed. Please verify payment details.",
    PAYMENT_HOSTED_PAGE_ERROR_MSG = "We apologize for the inconvenience, We are unable to process payments at this time. \n"
        + "Please try again or try our mobile ordering.\n "
        + "If you continue to have issues please contact guest services.",
    SHELL_PAYMENT_CONNECTION_LOST_MSG = "We couldn't complete your order because your internet connection was interrupted. "
        + "Please check your connection and try again.",
    MAX_CARD_ERROR_MSG = "To add a new card, please remove an existing card from your account.",
    CHANGE_PASSWORD = "changePassword",
    RESET_PASSWORD = "resetPassword",
    CURRENT_PASSWORD_ERROR_MSG = "Please enter a valid password",
    NEW_PASSWORd_ERROR_MSG = "Please enter a valid new password",
    CONFIRM_PASSWORD_ERROR_MSG = "Please confirm your new password",
    CONFIRM_PASSWORD_MUST_MATCH = "Confirm password must match",
    PERSONAL_INFO_UPDATE_ERROR_MSG = "An error occurred while updating personal info. Please try again!",
    CREATE_ACCOUNT_ERROR_MSG = "An error occurred while creating account. Please try again!",
    EXISTING_MEMBER_ERROR_MSG = "You are already a member of this program. Please Login!",
    SAVED_SUCCESS_MSG = "Your changes have been successfully saved",
    COUPON_ERROR_MSG = "The promo has been removed. Please try applying it again.",
    COUPON_REWARD_ERROR_MSG = "Promo and reward cannot be used together. Please choose either promo or reward.",
    GIFT_CARD_FOOTER_TEXT = "Gift cards are accepted at participating locations only and may not be valid at franchise or license locations, or restaurants in stadiums, airports, hospitals, hotels, campuses, and military bases.",
    LOGIN_DEEPLINK_KEY = "action",
    LOGIN_DEEPLINK_VALUE = "login",
    GIFT_CARD_NOT_FOUND_TEXT = "We're sorry, the card number and pin number you've entered doesn’t match a gift card in our system. For further assistance, please contact Guest Services.",
    GIFT_CARD_NOT_FOUND_TITLE = "Gift Card Not Found",
    GIFT_CARD_PIN_MODAL_TITLE = "Gift Card Pin Number",
    GIFT_CARD_PIN_MODAL_CONTENT = "Scratch off the box located on the top right of the back of your gift card to find your pin.",
    UNSUBSCRIBE_TITLE = "Unsubscribe",
    EBB_UNSUBSCRIBE_DESCRIPTION = "We're sorry to see you go! But if you would like to unsubscribe from Einstein Bros. Bagels emails you can do so here.",
    BRU_UNSUBSCRIBE_DESCRIPTION = "We're sorry to see you go! But if you would like to unsubscribe from Bruegger's Bagels emails you can do so here.",
    NNYB_UNSUBSCRIBE_DESCRIPTION = "We're sorry to see you go! But if you would like to unsubscribe from Noah's NY Bagels emails you can do so here.",
    EBB_UNSUBSCRIBE_PREFERENCE = 'ebbEmail',
    NNYB_UNSUBSCRIBE_PREFERENCE = 'nnybEmail',
    BRU_UNSUBSCRIBE_PREFERENCE = 'bruEmail',
    UNSUBSCRIBE_SUCCESS = 'Success. You have been unsubscribed.',
    GIFT_CARD_NUMBER_ERR = "Please enter a valid card number",
    GIFT_CARD_PIN_ERR = "Please enter a pin number",
    GIFT_CARD_WRONG_PIN_ERR = "Please enter a valid numeric pin. If your card does not have a pin or you cannot locate your pin, please contact customer service",
    AUTO_RELOAD_SETTINGS_UPDATE_MSG = "You’ve successfully updated auto-reload settings.",
    AUTO_RELOAD_SETTINGS_UPDATE_ERROR_MSG = "An error occurred while updating auto-reload settings. Please try again later!",
    DELETE_CARD_CONFIRMATION_MSG = "Delete the card ending in :cardAlias?",
    DELETE_PRIMARY_CARD_CONFIRMATION_MSG = "Delete the card ending in :cardAlias? This will disable your auto-reload.",
    AUTO_RELOAD_DISABLING_MSG = "By selecting Disable, funds will no longer be automatically added to your Rewards Card.",
    RECEIPT_VISIT_CODE_INVALID_MSG = "Receipt visit code invalid, please try again",
    RECEIPT_VISIT_CODE_SUCCESS_MSG = "Your points from your recent :brand visit have been claimed and are ready to use.",
    ACCOUNT_BALANCE_LIMIT = "ACCOUNT_BALANCE_LIMIT",
    EBB_CATERING = 'ebcatering.com',
    NOAHS_CATERING = 'noahscatering.com',
    BRUEGGERS_CATERING = 'brueggerscatering.com',
}

export default Constants;

export const MAX_ALLOWED_CARDS = 3;
export const ACCOUNT_BALANCE_LIMIT = 200;

const SORTED_US_STATES: string [] = ["AL", "AK", "AS", "AZ", "AR", "CA", "CO", "CT", "DE", "DC", "FM", "FL", "GA", "GU", "HI",
    "ID", "IL", "IN", "IA", "KS", "KY", "LA", "ME", "MH", "MD", "MA", "MI", "MN", "MS", "MO", "MT", "NE", "NV", "NH",
    "NJ", "NM", "NY", "NC", "ND", "MP", "OH", "OK", "OR", "PW", "PA", "PR", "RI", "SC", "SD", "TN", "TX", "UT", "VT",
    "VI", "VA", "WA", "WV", "WI", "WY", "Armed Forces (AA)", "Armed Forces (AE)", "ArmedForces (AP)"]
    .sort();
export const US_STATES = Object.freeze(SORTED_US_STATES);

export enum AppEvents {
    ADD_FUNDS_RECAPTCHA_SUCCESS = "evt_AddFundsStored_recaptcha_success",
    ADD_FUNDS_RECAPTCHA_FAILED = "evt_AddFundsStored_recaptcha_failed",
    ADD_FUNDS_RECAPTCHA_DISABLED = "evt_AddFundsStored_recaptcha_disabled",
    ADD_FUNDS_RESPONSE_SUCCESS = "evt_Add_Funds_resp",
    ADD_FUNDS_RESPONSE_ERROR = "evt_Add_Funds_err",
    FISERV_CARDS_ERROR = "evt_FiservCard_err",
    FISERV_CARDS_SUCCESS = "evt_FiservCard_err",
    ADD_FUNDS_FISERV_RESPONSE_SUCCESS = "evt_AddFundsFiserv_resp",
    ADD_FUNDS_FISERV_RESPONSE_ERROR = "evt_AddFundsFiserv_resp",

    PAYMENT_SALEORDER_RECAPTCHA_SUCCESS = "evt_Payment_SaleOrder_recaptcha_success",
    PAYMENT_SALEORDER_RECAPTCHA_FAILED = "evt_Payment_SaleOrder_recaptcha_failed",
    PAYMENT_SALEORDER_RECAPTCHA_DISABLED = "evt_Payment_SaleOrder_recaptcha_disabled",
    PAYMENT_SALEORDER_FISERV_HOSTED_PAGES_ERROR = "evt_FiservHostedPages_err",
    PAYMENT_SALEORDER_FINAL_PROCESS = "_FINAL_PROCESS",
    PAYMENT_SALEORDER_FINAL_ORDER_SUCCESS = "_FINAL_ORDER_SUBMIT_WITH_PICKUP_TYPE",
    PAYMENT_SALEORDER_FINAL_ORDER_ERROR = "_FINAL_ORDER_SUBMIT_WITH_PICKUP_TYPE_ERR",
    PAYMENT_SALEORDER_FINAL_COMPLETE = "PAYMENT_ORDER_COMPLETE",
    PAYMENT_SALEORDER_FINAL_ERROR = "PAYMENT_ORDER_ERROR",
    PAYMENT_SALEORDER_USER_PROFILE_UPDATE_ERROR = "_USER_PROF_UEFF",
    PAYMENT_SALEORDER_USER_PROFILE_UPDATE = "USER_PROF_UPD_ON_ORDER_SUCCESS",

    PAYMENT_RECAPTCHA_SUCCESS = "evt_Payment_recaptcha_success",
    PAYMENT_RECAPTCHA_FAILED = "evt_Payment_recaptcha_failed",
    PAYMENT_RECAPTCHA_DISABLED = "evt_Payment_recaptcha_disabled",
    PAYMENT_ADD_FUNDS_FISERV_SUCCESS = "evt_Payment_Add_Funds_Fiserv_success",
    PAYMENT_ADD_FUNDS_FISERV_ERROR = "evt_Payment_Add_Funds_Fiserv_err",
    PAYMENT_ADD_FUNDS_ERROR = "_ADD_PAYMENT",
    PAYMENT_ACCOUNT_BILLING_UPDATE_COMPLETE = "ACCOUNT_BILLING_UPDATE_COMPLETE",
    PAYMENT_ACCOUNT_BILLING_UPDATE_ERROR = "ACCOUNT_BILLING_UPDATE_ERROR",

    FISERV_HOSTED_PAGE_ERROR = "evt_FiservHostedPages_err",

    AUTO_RELOAD_FUNDS_FAILED = "evt_AutoReloadFunds_failed",
    AUTO_RELOAD_FUNDS_SUCCESS = "evt_AutoReloadFunds_success",
    VAULT_CARD_FAILED = "evt_VaultCard_failed",

    GET_USER_DETAILS = "_USER_PROF_UEFF",

    UNSUBSCRIBE_REQUEST = "evt_Unsubscribe_req",
    UNSUBSCRIBE_RESPONSE = "evt_Unsubscribe_resp",
    UNSUBSCRIBE_ERROR = "evt_Unsubscribe_err",

    APPLY_VISIT_CODE_FAILED = "evt_ApplyVisitCode_failed",
    APPLY_VISIT_CODE_SUCCESS = "evt_ApplyVisitCode_success",

    PARSING_ERROR = "PARSING_ERROR",
    NOTIFICATION_UPDATE_ERROR = "_NOTIFICATION_UPDATE_ERR",
    NOTIFICATION_UPDATE_INFO_PAYLOAD = "evt_NotificationUpdate_req",
    GA4_EVENTS = "evt_GA4",
}

export enum Routes {
    HOME = '/',
    MENU = '/menu',
    REWARDS = '/rewards',
    LOCATIONS = '/locations',
    CATEGORY = '/category',
    MY_ACCOUNT = '/myaccount',
    MY_ACCOUNT_NOTIFICATIONS_ROUTE = "/myaccount/notifications",
    WEB_GIFTCARD_TRANSFER_ROUTE = "/myaccount/giftcard/transfer",
    MOBILE_GIFTCARD_TRANSFER_ROUTE = "/mobile/giftcard/transfer",
}

export const SNACKBAR_DURATION = 2000;

export const SUCCESS_STATUS = "SUCCESS";
export const CARD_ACTIVE = "ACTIVE";
export const SUCCESS = "Success";
export const FAILURE = "Failure";

//AppInsights Constants
export const REACT_COMPONENT_ENGAGED_TIME = "React Component Engaged Time (seconds)";

//CDN configurations
export const CDN_BASE_URL: string = process.env.REACT_APP_CDN_BASE_URL || "https://dastore-eea4hdcsdnb9h8cj.z01.azurefd.net";
export const REWARDS_FOLDER = "rewards_home";
export const GIFT_CARDS_FOLDER = "gift_cards";

//Rewards Constants
export const REDEEM_SUCCESS_MESSAGE = (rewardTitle: string) => `Would you like to proceed with adding your ${rewardTitle} to your online order? You can choose your reward item on the next screen.`;
export const MARKETING_BANNER_BODY_TEXT = "Treat them to an Einstein Bros. Bagels breakfast and show them you’ve got great taste.";
export const MARKETING_BANNER_BODY_HEADER = "Bagels Make Great Gifts";
export const SHOP_GIFT_CARDS = "SHOP GIFT CARDS";
export const POINTS = (points: string) => `${points} Points`;
// Future Orders constants
export const FUTURE_ORDERS_FEATURE_FLAG = "FUTURE_ORDERS_ENABLED";
export const LOYALTY_TYPE = "LOYALTY";
export const GUEST_TYPE = "GUEST";
export const NOT_AVAILABLE = "Not Available";
export const CREDIT_TYPE = "CREDIT";
export const WEEK_DAYS: string[] = ["sunday", "monday", "tuesday", "wednesday", "thursday", "friday", "saturday"];
export const ASAP_TIME = "ASAP (15-20 MIN)";
export const ASAP = "ASAP";
//Fallback literlas for Terms and Conditions
export const EBB_TERMS = "Rewards is a customer loyalty program, which rewards customers for making purchases or participating in other qualifying activities. You can register for the program in-store at participating Einstein Bros. Bagels locations or online at rewards.einsteinbros.com. Valid at participating Einstein Bros. Bagels stores. For more information, visit rewards.einsteinbros.com.";
export const NNYB_TERMS = "Noah's Rewards is a customer loyalty program, which rewards customers for making purchases or participating in other qualifying activities. You can register for the program in-store at participating Noah's New York Bagels locations or online at rewards.noahs.com. Valid at participating Noah's New York Bagels stores. For more information, visit rewards.noahs.com.";
export const BRU_TERMS = "Bruegger's Bagels Inner Circle is a customer loyalty program, which rewards customers for making purchases or participating in other qualifying activities. You can register for the program in-store at participating Bruegger's Bagels locations or online at rewards.brueggers.com. Valid at participating Bruegger's Bagels stores. For more information, visit rewards.brueggers.com.";
//Cart Constants
export const HELLO_MESSAGE = (name: string) => `Hello, ${name}!`;
export const POINTS_MESSAGE = (balancePoints: string) => `Points: ${balancePoints}`;
export const BALANCE_MESSAGE = (balance: string) => `Balance: $${balance}`;
export const SIZE_CONFIG: string[] = ["Small", "Medium", "Large"];
export const PASSWORD_MIN_LENGTH = 8;
export const MAX_AGE = 120;
export const MIN_AGE = 13;
export enum DateFormat {
    MM_DD_YYYY = "MM/dd/yyyy",
    YYYY_MM_DD = "yyyy-MM-dd",
    yyyy_MM_dd_HH_mm_ss = "yyyy-MM-dd HH:mm:ss",
    HH_mm = "HH:mm",
    MM_dd_yyyy_h_mm_a = "MM/dd/yyyy h:mm a",
  }
export const MOBILE_WIDTH = 576;
export const TABLET_WIDTH = 768;
export enum UserType {
    GUEST = 'guest',
    LOYALTY = 'loyalty',
}

// Recent Orders
export const ORDER_STATUS_PENDING = 'pending';
// one trust query params
export const OT_QUERY_PARAMS = ['otpreview', 'otgeo', 'otreset'];

export enum MyAccountMenu {
    PERSONAL_INFO = "Personal Info",
    NOTIFICATIONS = "Notifications",
    CHANGE_PASSWORD = "Change Password",
    AUTO_RELOAD_SETTINGS = "Auto Reload Settings",
    GIFT_CARD_TRANSFER = 'Gift Card Transfer',
}

export const MOBILE_GIFTCARD_TRANSFER_NOT_ALLOWED_MSG = "Sorry, gift cards cannot be transferred at this time. Please try again later.";

export enum EnvConfig {
    GIFT_CARD_NUMBER_SUPPORTED_DIGITS = 'GIFT_CARD_NUMBER_SUPPORTED_DIGITS',
    GIFT_CARD_PIN_SUPPORTED_LENGTHS = 'GIFT_CARD_PIN_SUPPORTED_LENGTHS',
}
export const UNAUTHORIZED_CODE = 401;
export enum GlobalAlertType {
    MAINTENANCE = 'maintenance',
    WARNING = 'warning',
}
export enum SessionStorageKeys {
    SCHEDULE_IN = 'scheduleIn',
    PICK_UP_DATE = 'pickUpDate',
}

export enum ShellBridgeEvents {
    MOBILE_NAV_CANCEL = "mobile-navBack-cancel",
    MOBILE_NAV_POP = "mobile-navBack-pop",
    MOBILE_ORDERCON_POPHOME = "mobile-orderConfirmation-popToHome",
    MOBILE_BUTTONTAP_CANCEL_PAYMENT_CANCEL = "mobile-buttonTap-cancelPayment-cancel",
    MOBILE_BUTTONTAP_POPTOHOME_CANCEL = "mobile-buttonTap-popToHome-cancel",
    MOBILE_BUTTONTAP_POPTOHOME_OK = "mobile-buttonTap-popToHome-ok",
}

export enum ShellCustomEvent {
    WEB_BUTTON_TAP = "web-buttonTap",
    CANCEL_PAYMENT = "cancelPayment",
    POP_TO_HOME = "popToHome",
}

export enum ShellHeaderTitle {
    MY_CART = "My Cart",
    CLOSE = "close",
    CANCEL = "cancel",
    FINISH_PAY = "Finish & pay",
    CONFIRMATION = "Confirmation",
    CHECKOUT = "Checkout",
}

export const QUERY_UNINITIALIZED = "uninitialized";
